import React, { Fragment } from 'react';
import { ContactIcon } from 'v3/shared/components/ContactIcon';
import { SellerContactIconsProps } from 'v3/shared/components/SellerContactIcons/types';

export const SellerContactIcons: React.FC<SellerContactIconsProps> = ({ phoneAreaCode, phoneNumber, email }) => {
  const phoneValue = phoneAreaCode && phoneNumber ? `(${phoneAreaCode}) ${phoneNumber}` : '';

  return (
    <Fragment>
      <ContactIcon typeContact="phone" value={phoneValue} tooltipWhenMissing="Telefone não cadastrado" />
      <ContactIcon typeContact="email" value={email ?? ''} tooltipWhenMissing="E-mail não cadastrado" />
    </Fragment>
  );
};
